import { startCase } from '../../../helpers/socratesLodash';
import { difference } from 'lodash';

export const getFormattedRegions = (statuses) => {
  return statuses.reduce((carry, region) => {
    carry[region] = startCase(region);
    return carry;
  }, {});
};

export const getSchemeList = (isSchemeGroup, schemes) => {
  return schemes.filter((scheme) => scheme?.status === 'test');
};

export const getDestinationsMappings = (mapping, excludeCountries, destinationList) => {
  if (!mapping || !destinationList?.length) {
    return undefined;
  }

  const countryKeys = Object.keys(mapping);
  const destinationsMappingArray = countryKeys.map((countryKey) => {
    const region = mapping[countryKey];

    return { id: countryKey, country: countryKey, status: region };
  });

  const destinationNames = destinationList.map((d) => {
    return d.attributes.name;
  });

  const mappingNames = destinationsMappingArray.map((d) => {
    return d.country;
  });

  const unassignedCountries = difference(destinationNames, mappingNames);

  return {
    mappings: destinationsMappingArray,
    destinationNames: destinationNames,
    unassignedCountries: unassignedCountries,
    excludeCountries: excludeCountries,
  };
};
